import React, { useState, useRef, useEffect, forwardRef } from "react";
import { useField } from "@unform/core";

import { MdInsertPhoto } from "react-icons/md";
import { toast } from "react-toastify";

import { Container, DefaultAvatar } from "./styles";
import apiGd from "../../../../services/apiGd";

const Avatar = forwardRef(({ name, value, setRestaurantData = null, ...rest }, ref) => {
  const { fieldName, registerField, error } = useField(name);

  const [fileId, setFileId] = useState(value && value.id);
  const [preview, setPreview] = useState(value && value.url);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: "dataset.fileid",
      clearValue() {
        ref.value = "";
        setPreview(null);
      },
    });
  }, [fieldName, registerField]);

  useEffect(() => {
    if (value) {
      setPreview(value.url);
      setFileId(value.id);
    }

    console.log('@@ avatar value', value);
  }, [value]);

  async function handleChange(e) {
    try {
      const data = new FormData();
      const token = localStorage.getItem("@QRExpress:tokenGd");
      data.append("file", e.target.files[0]);

      if (fileId) {
        await apiGd.delete(`restaurants/files/${fileId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      const response = await apiGd.post("admin/files", data, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const { id, url } = response.data;

      if (setRestaurantData) {
        setRestaurantData((old) => {
          return {
            ...old,
            avatar_id: id
          };
        });
      }

      setFileId(id);
      setPreview(url);
    } catch (err) {
      toast.error(error.response.data.error);
      console.log("erro no avatar")
    }
  }

  return (
    <Container>
      <label htmlFor="avatar">
        {preview ? (
          <img
            src={preview}
            style={{ height: 200, width: 300 }}
            alt="User Avatar"
          />
        ) : (
          <DefaultAvatar>
            <MdInsertPhoto size={45} color="#ddd" />
            <span>Adicionar Logo</span>
          </DefaultAvatar>
        )}

        <input
          type="file"
          id="avatar"
          accept="image/*"
          data-fileid={fileId}
          onChange={handleChange}
          ref={ref}
          {...rest}
        />
      </label>
    </Container>
  );
});

export default Avatar;
